import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {ArmaRestAnalysis, ArmaRestInfoComp, ArmaRestOrderList} from 'src/app/classes/json-interface';
import {ArmaDate, getJsonLocalStorage} from 'src/app/classes/utilit';
import {AppToolbarService} from 'src/app/components/toolbar/services/app-toolbar.service';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';
import {g_params} from '../../classes/global-param';
import {FilterType, IColumnFilter, TableFilter} from '../../components/arma-filter-item/ColumnFilter';
import {SteelListStatus} from '../../classes/const';
import {UtilitAnalysis} from '../../classes/decorticage/Utilits-analysis';

const CST_MAT_COLUMN_OrderCode = 'OrderCode';
const CST_MAT_COLUMN_EXT_ORDER_CODE = 'CST_MAT_COLUMN_EXT_ORDER_CODE';
const CST_MAT_COLUMN_CreationDate = 'CreationDate';
const CST_MAT_COLUMN_CUSTOMER_REF = 'CST_MAT_COLUMN_CUSTOMER_REF';
const CST_MAT_COLUMN_Drawing = 'Drawing';
const CST_MAT_COLUMN_Weight = 'Weight';
const CST_MAT_COLUMN_Production = 'Production';
const CST_MAT_COLUMN_Delivery = 'Delivery';
const CST_MAT_COLUMN_PersonInCharge = 'PersonInCharge';
const CST_MAT_COLUMN_PlannedDelivDate = 'PlannedDelivDate';
const CST_MAT_COLUMN_Action = 'Action';

const CST_STORAGE_VISIBILITY_COLUMN_LIST_DECO = 'CST_STORAGE_VISIBILITY_COLUMN_LIST_DECO';

interface ParamVisiblilityColumn {
  displayExtOrderCode?: boolean;
  displayCreationDate?: boolean;
  displayCustomerRef?: boolean;
  displayDrawing?: boolean;
  displayWeight?: boolean;
  displayProduction?: boolean;
  displayDelivery?: boolean;
  displayPersonInCharge?: boolean;
  displayPlannedDelivDate?: boolean;
  displayInfoComp?: boolean;
}

const CST_DEFAULT_VISILITY_COLUMN: ParamVisiblilityColumn = {
  displayExtOrderCode: true,
  displayCreationDate: true,
  displayCustomerRef: true,
  displayDelivery: true,
  displayDrawing: true,
  displayInfoComp: true,
  displayPersonInCharge: true,
  displayPlannedDelivDate: true,
  displayProduction: true,
  displayWeight: true
};

/**
 * Structure de donnée du mat table
 */
interface OrderSteelListData {
  readonly Source: 'Order'|'SteelList';
  readonly SourceJson: ArmaRestAnalysis|ArmaRestOrderList;
  readonly Code: string;
  readonly JoiningCode: number;
  readonly extCode: string;
  readonly CreationDate: string;
  readonly UnixCreationDate: number;
  readonly UnixPlannedDelivDate: number;
  readonly CustomerRef: string;
  readonly Drawing: string;
  readonly Weight: number;
  readonly ProductionStatusStr: string;
  readonly DeliveryStatusStr: string;
  readonly ProductionStatusDescription: string;
  readonly DeliveryStatusDescription: string;
  readonly PersonInCharge: string;
  readonly PlannedDeliveryDate: string;
  readonly infoComp: {};
}

// Liste des colonnes filtrées, le type de filtre et le nom de la variable de l'objet Contrat que l'on va testé pour le filtre
const FILTERED_COLUMNS: IColumnFilter<OrderSteelListData>[] = [
  {columnName: CST_MAT_COLUMN_OrderCode, filterType: FilterType.Checkbox, matchedVariable: 'Source'},
  {columnName: CST_MAT_COLUMN_EXT_ORDER_CODE, filterType: FilterType.Checkbox, matchedVariable: 'extCode'},
  {columnName: CST_MAT_COLUMN_Delivery, filterType: FilterType.Checkbox, matchedVariable: 'DeliveryStatusStr'},
  {columnName: CST_MAT_COLUMN_Production, filterType: FilterType.Checkbox, matchedVariable: 'ProductionStatusStr'},
  {columnName: CST_MAT_COLUMN_CreationDate, filterType: FilterType.Datebox, matchedVariable: 'UnixCreationDate'},
  {columnName: CST_MAT_COLUMN_PersonInCharge, filterType: FilterType.Checkbox, matchedVariable: 'PersonInCharge'}
];

@Component({
  selector: 'app-list-deco',
  templateUrl: './list-deco.component.html',
  styleUrls: ['./list-deco.component.css']
})
export class ListDecoComponent implements OnInit {

  // Constante accesible pour le html
  public readonly CST_MAT_COLUMN_OrderCode = CST_MAT_COLUMN_OrderCode;
  public readonly CST_MAT_COLUMN_EXT_ORDER_CODE = CST_MAT_COLUMN_EXT_ORDER_CODE;
  public readonly CST_MAT_COLUMN_CreationDate = CST_MAT_COLUMN_CreationDate;
  public readonly CST_MAT_COLUMN_CUSTOMER_REF = CST_MAT_COLUMN_CUSTOMER_REF;
  public readonly CST_MAT_COLUMN_Drawing = CST_MAT_COLUMN_Drawing;
  public readonly CST_MAT_COLUMN_Weight = CST_MAT_COLUMN_Weight;
  public readonly CST_MAT_COLUMN_Production = CST_MAT_COLUMN_Production;
  public readonly CST_MAT_COLUMN_Delivery = CST_MAT_COLUMN_Delivery;
  public readonly CST_MAT_COLUMN_PersonInCharge = CST_MAT_COLUMN_PersonInCharge;
  public readonly CST_MAT_COLUMN_PlannedDelivDate = CST_MAT_COLUMN_PlannedDelivDate;
  public readonly CST_MAT_COLUMN_Action = CST_MAT_COLUMN_Action;

  public readonly visibilityColumn: ParamVisiblilityColumn = getJsonLocalStorage(CST_STORAGE_VISIBILITY_COLUMN_LIST_DECO, CST_DEFAULT_VISILITY_COLUMN);

  public HTML_TableDataSource: MatTableDataSource<OrderSteelListData> = new MatTableDataSource<OrderSteelListData>([]);
  public HTML_TableaHeader: string[] = [];
  public HTML_ArrayInfoCompName: string[] = [];

  public mHasExtOrderCode = false;

  public mArrayInfoComp: ArmaRestInfoComp[] = [];

  @ViewChild(MatSort, {static: true}) mMatSort!: MatSort;
  @ViewChild('matTableListDeco', {static: true}) mMatTable!: MatTable<OrderSteelListData>;
  @ViewChild('TablePaginator', { static: true }) tablePaginator!: MatPaginator;

  public HTML_ShowLoadingSpinner: boolean = false;
  public mTableFilter: TableFilter<OrderSteelListData> = new TableFilter(FILTERED_COLUMNS);

  public readonly mUseJoiningCode: boolean = g_params.useJoiningCode;

  constructor(private mArmaServMethod: ArmaServServerMethods,
              private mToolbar: AppToolbarService) {

  }

  ngOnInit() {
    this.mToolbar.toolbarPageTitle = 'Suivi chantier';
    this.mToolbar.getObservableSiteChange().subscribe(() => this.clearAndLoadOrderList().catch(console.error)); // Refresh la liste a chaque changement de chantier
    this.HTML_TableDataSource.sort = this.mMatSort;
    this.HTML_TableDataSource.sortingDataAccessor = analysisSortingDataAccessor;
    this.HTML_TableDataSource.filterPredicate = data => this.mTableFilter.match(data); // Maj du filterPredicate
    this.HTML_TableDataSource.paginator = this.tablePaginator;
    this.updateTableHeader(false);
    this.clearAndLoadOrderList().catch(console.error);
  }

  private async clearAndLoadOrderList() {
    this.HTML_ShowLoadingSpinner = true;
    this.HTML_TableDataSource.data = [];
    try {
      const newDataSource: OrderSteelListData[] = [];
      const arrayWebSteelList = await this.mArmaServMethod.loadListSteelList(this.mToolbar.selectedSiteCode);
      const arrayAnalysis = await this.mArmaServMethod.getListOrder(this.mToolbar.selectedSiteCode);
      this.mArrayInfoComp = await this.mArmaServMethod.getListorderInfoComp(this.mToolbar.selectedSiteCode);

      this.mHasExtOrderCode = false;

      for (const webSteelList of arrayWebSteelList) {
        // On ne prend pas les listes d'acier qui sont validé car il apparaissent en tant que contrat
        if (webSteelList.StatusInteger == SteelListStatus.stValidate)
          continue;
        newDataSource.push(convertSteelDataToOrderData(webSteelList));
      }
      for (const analysis of arrayAnalysis) {
        if (analysis.extOrderCode)
          this.mHasExtOrderCode = true;
        newDataSource.push(convertOrderAnalysisData(analysis, this.mArrayInfoComp));
      }

      this.HTML_TableDataSource.data = newDataSource;
      this.HTML_ArrayInfoCompName = [... new Set(this.mArrayInfoComp.reduce((previousValue, currentValue) => {
        // @ts-ignore TODO: TS2769: No overload matches this call.
        return previousValue.concat(currentValue.ArrayInfoComp.map(value => value.INFO_LIBELLE));
      }, []))];

      // Génération des colonnes de filtre du tableau
      this.mTableFilter.generateColumnFiltersItemFromArray(FILTERED_COLUMNS, this.HTML_TableDataSource.data);
      this.filterOrder();
      this.updateTableHeader(false);
    } finally {
      this.HTML_ShowLoadingSpinner = false;
    }
  }

  public updateTableHeader(save: boolean) {
    this.HTML_TableaHeader.length = 0;
    this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_OrderCode);
    if (this.mHasExtOrderCode && this.visibilityColumn.displayExtOrderCode)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_EXT_ORDER_CODE);
    if (this.visibilityColumn.displayCreationDate)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_CreationDate);
    if (this.visibilityColumn.displayCustomerRef)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_CUSTOMER_REF);
    if (this.visibilityColumn.displayDrawing)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_Drawing);
    if (this.visibilityColumn.displayWeight)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_Weight);
    if (this.visibilityColumn.displayProduction)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_Production);
    if (this.visibilityColumn.displayDelivery)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_Delivery);
    if (this.visibilityColumn.displayPersonInCharge)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_PersonInCharge);
    if (this.visibilityColumn.displayPlannedDelivDate)
      this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_PlannedDelivDate);

    // Ajout des information complémentaire
    if (this.visibilityColumn.displayInfoComp)
      this.HTML_TableaHeader.push(...this.HTML_ArrayInfoCompName);

    this.HTML_TableaHeader.push(this.CST_MAT_COLUMN_Action);

    if (save)
      localStorage.setItem(CST_STORAGE_VISIBILITY_COLUMN_LIST_DECO, JSON.stringify(this.visibilityColumn));
  }

  /**
   * Pour déclencher le filtre du tableau
   */
  public filterOrder() {
    this.HTML_TableDataSource.filter = Date.now().toString();
  }

  public showOrder(element: OrderSteelListData, download: boolean = false) {
    this.mArmaServMethod.downloadOrder(element.Code, download).catch(console.error);
  }

  public downloadAllDeco() {
    this.mArmaServMethod.downloadAllOrder().catch(console.error);
  }

  public asTableData(tableData: OrderSteelListData): OrderSteelListData {
    return tableData;
  }

  public asKeyOfTableData(val: keyof OrderSteelListData): keyof OrderSteelListData {
    return val;
  }

  public get toolbarSelectedSiteCode(): string {
    return this.mToolbar.selectedSiteCode;
  }
}

const analysisSortingDataAccessor = (item: OrderSteelListData, property: string): string|number => {
  switch (property) {
    case CST_MAT_COLUMN_OrderCode: // Number.MAX_VALUE seulement visible pour le tri, permet d'afficher les liste d'acier en premier
      return (item.Source == 'SteelList') ? Number.MAX_VALUE : item.JoiningCode;
    case CST_MAT_COLUMN_Weight:
      return item.Weight;
    case CST_MAT_COLUMN_CreationDate:
      return item.UnixCreationDate;
    case CST_MAT_COLUMN_CUSTOMER_REF:
      return item.CustomerRef;
    case CST_MAT_COLUMN_PlannedDelivDate:
      return item.UnixPlannedDelivDate;
    case CST_MAT_COLUMN_Drawing:
      return item.Drawing;
    case CST_MAT_COLUMN_Production:
      return item.ProductionStatusStr;
    case CST_MAT_COLUMN_Delivery:
      return item.DeliveryStatusStr;
    case CST_MAT_COLUMN_PersonInCharge:
      return item.PersonInCharge;
    case CST_MAT_COLUMN_EXT_ORDER_CODE:
      return item.extCode;
    default:
      // @ts-ignore //TODO: TS7053: Element implicitly has an 'any' type
      return item[property] ?? '';
  }
};

const getInterfaceInfoComp = (orderCode: string, arrayInfoComp: ArmaRestInfoComp[]): {} => {
  const result = {};
  const armaRestInfoComp = arrayInfoComp.find(value => value.AnalysisCode === orderCode);
  if (!armaRestInfoComp)
    return result;
  // @ts-ignore TODO: TS7053: Element implicitly has an 'any' type
  armaRestInfoComp.ArrayInfoComp.forEach(infoComp => result[infoComp.INFO_LIBELLE] = infoComp.VALEUR);
  return result;
};

const convertOrderAnalysisData = (armaOrder: ArmaRestAnalysis,
                                  arrayArmaRestInfoComp: ArmaRestInfoComp[]): OrderSteelListData => {
  return {
    Source: 'Order',
    SourceJson: armaOrder,
    Code: armaOrder.OrderCode,
    JoiningCode: armaOrder.JoiningCode,
    extCode: armaOrder.extOrderCode,
    CreationDate: armaOrder.CreationDate,
    UnixCreationDate: armaOrder.UnixCreationDate,
    PlannedDeliveryDate: armaOrder.PlannedDelivDate,
    UnixPlannedDelivDate: armaOrder.UnixPlannedDelivDate,
    CustomerRef: armaOrder.ClientRef,
    Drawing: armaOrder.Drawing,
    Weight: armaOrder.Weight,
    ProductionStatusStr: armaOrder.Production,
    DeliveryStatusStr: armaOrder.Delivery,
    ProductionStatusDescription: armaOrder.Production,
    DeliveryStatusDescription: armaOrder.Delivery,
    PersonInCharge: armaOrder.PersonInCharge,
    infoComp: getInterfaceInfoComp(armaOrder.OrderCode, arrayArmaRestInfoComp)
  };
};

const convertSteelDataToOrderData = (armaRestOrderList: ArmaRestOrderList): OrderSteelListData => {
  return {
    Source: 'SteelList',  // Source
    SourceJson: armaRestOrderList,  // SourceJson
    Code: armaRestOrderList.Code,  // Code
    JoiningCode: armaRestOrderList.OrderJoiningCode, // JoiningCode
    extCode: '', // extCode
    CreationDate: armaRestOrderList.DateCreate,  // CreationDate
    UnixCreationDate: armaRestOrderList.UnixDateCreate, // UnixCreationDate
    UnixPlannedDelivDate: armaRestOrderList.DateDelivery, // UnixPlannedDelivDate
    CustomerRef: armaRestOrderList.CustomerRef,  // CustomerRef
    Drawing: armaRestOrderList.Designation, // Drawing
    Weight: -1, // On ne connais pas le poids de la liste d'acier  // Weight
    ProductionStatusStr: armaRestOrderList.Status, // ProductionStatusStr
    DeliveryStatusStr: '',  // DeliveryStatusStr
    ProductionStatusDescription: UtilitAnalysis.getDescriptionStatusSteelList(armaRestOrderList.StatusInteger), // ProductionStatusDescription
    DeliveryStatusDescription: '',  // DeliveryStatusDescription
    PersonInCharge: '', // PersonInCharge
    PlannedDeliveryDate: ArmaDate.createFromUnixTime(armaRestOrderList.DateDelivery).toDate(), // PlannedDeliveryDate
    infoComp: {}  // infoComp
  };
};
